// extracted by mini-css-extract-plugin
module.exports = {"preview":"aAVD_","category":"_2Z18s"};